import * as React from "react";
import { forwardRef } from "react";
const SvgIcWrong20 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.42661 10.0908L13.3764 15.0405L15.1441 13.2727L10.1943 8.26422L15.1441 3.37324L13.3764 1.60547L8.42654 6.49645L3.4767 1.60556L1.70909 3.37324L6.65868 8.32307L1.60547 13.3763L3.37324 15.1441L8.42661 10.0908Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcWrong20);
export { ForwardRef as ReactComponent };
